import { Checkbox, DatePicker, Form, Input, Select, TimePicker } from 'antd';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import regex, { USER_TYPE_OPTIONS } from '../../../constants/system.keys';

const { Option } = Select;

const AddMemberComponent = ({ namespace, form, setUserType }) => {
  const { t } = useTranslation();
  const { detailRoleOfCustomer } = useSelector((state) => state);
  const [, forceUpdate] = useState();
  const phoneNumberRef = useRef(null);
  const [authMethod, setAuthMethod] = useState('otp');

  useEffect(() => {
    forceUpdate({});
    return () => {
      form.resetFields();
    };
  }, [form]);

  useEffect(() => {
    if (namespace) {
      form.setFieldsValue({
        namespace: namespace,
        liveTimeout: moment('1:00', 'HH:mm'),
      });
    }
  }, [form, namespace]);

  useEffect(() => {
    if (phoneNumberRef.current) {
      setTimeout(() => {
        phoneNumberRef.current.input.focus();
      }, 1);
    }
  }, [phoneNumberRef]);

  const handleAuthMethodChange = (value) => {
    setAuthMethod(value);
  };

  const handleChangeUserType = (value) => {
    form.setFieldsValue({ detailRoles: [] });
    setUserType(value);
  };

  return (
    <>
      <Form.Item
        name="authMethod"
        label={t('Authentication')}
        rules={[
          {
            required: true,
            message: t('Please select an authentication method!'),
          },
        ]}
      >
        <Select
          placeholder={t('Select authentication method')}
          onChange={handleAuthMethodChange}
        >
          <Option value="otp">OTP</Option>
          <Option value="credentials">Credentials</Option>
        </Select>
      </Form.Item>

      {authMethod === 'otp' && (
        <Form.Item
          name="phonenumber"
          label={t('Phone number')}
          rules={[
            {
              required: true,
              message: t('Please input the phone number!'),
            },
            {
              pattern: regex.isMobile,
              message: t('Please input the phone number!'),
            },
          ]}
        >
          <Input ref={phoneNumberRef} placeholder={t('Phone number')} />
        </Form.Item>
      )}

      {authMethod === 'credentials' && (
        <>
          <Form.Item
            name="username"
            label={t('Username')}
            rules={[
              {
                required: true,
                message: t('Please input the username!'),
              },
              {
                pattern: regex.isUserNameApi,
                message: t('Username is not valid!'),
              },
            ]}
          >
            <Input placeholder={t('Username')} />
          </Form.Item>

          <Form.Item
            name="password"
            label={t('Password')}
            rules={[
              {
                required: true,
                message: t('Please input the password!'),
              },
              {
                pattern: regex.isPassword,
                message: t('Password is not valid!'),
              },
            ]}
          >
            <Input.Password placeholder={t('Password')} />
          </Form.Item>
        </>
      )}

      <Form.Item
        name="namespace"
        label={t('Namespace')}
        rules={[
          {
            required: true,
            message: t('Please input the namespace!'),
          },
          {
            pattern: regex.isurl,
            message: t('Please input the namespace!'),
          },
          {
            max: 80,
            message: t('Please input up to 80 characters!'),
          },
        ]}
      >
        <Input disabled placeholder={t('Namespace')} />
      </Form.Item>

      <Form.Item
        name="externalUserId"
        label={t('External Id')}
      // rules={[
      //   {
      //     pattern: /^\d*$/,
      //     message: t('Please enter only numbers!'),
      //   },
      // ]}
      >
        <Input placeholder={t('External Id')} />
      </Form.Item>

      <Form.Item
        name="fullName"
        label={t('Full name')}
        rules={[
          {
            required: true,
            message: t('Please input the name of member!'),
          },
          {
            pattern: regex.isName,
            message: t('Please enter only letters and numbers!'),
          },
          {
            max: 80,
            message: t('Please input up to 80 characters!'),
          },
        ]}
      >
        <Input placeholder={t('Full name')} />
      </Form.Item>
      <Form.Item
        name="email"
        label={t('Email')}
        rules={[
          {
            required: true,
            message: t('Please input the email!'),
          },
          {
            type: 'email',
            message: t('Email address is not valid!'),
          },
          {
            max: 80,
            message: t('Please input up to 80 characters!'),
          },
        ]}
      >
        <Input placeholder={t('Email')} />
      </Form.Item>
      <Form.Item
        name="position"
        label={t('Position')}
        rules={[
          {
            pattern: regex.isName,
            message: t('Please enter only letters and numbers!'),
          },
          {
            max: 80,
            message: t('Please input up to 80 characters!'),
          },
        ]}
      >
        <Input placeholder={t('Position')} />
      </Form.Item>
      <Form.Item
        name="role"
        label={t('UserType')}
        rules={[
          {
            required: true,
            message: t('Please select the permission of member!'),
          },
        ]}
      >
        <Select
          placeholder={t('Permission of member')}
          onChange={handleChangeUserType}
        >
          {USER_TYPE_OPTIONS.map((item) => (
            <Option value={item.value}>{item.label}</Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item name="detailRoles" label={t('Role')}>
        <Select mode="multiple" placeholder={t('Role of member')}>
          {detailRoleOfCustomer?.map((role) => (
            <Option key={role} value={role}>
              {role?.replaceAll('-', ' ')}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item name="liveTimeout" label={t('Live Timeout')}>
        <TimePicker format="HH:mm" showNow={false} allowClear={false} />
      </Form.Item>
      <Form.Item
        label={t('Active Status')}
        name="accountStatus"
        valuePropName="checked">
        <Checkbox />
      </Form.Item>
      <Form.Item
        label={t('Expire Time')}
        name="expireTime">
        <DatePicker showTime />
      </Form.Item>
      <Form.Item
        label={t('Enable Watermark')}
        name="enableWatermark"
        valuePropName="checked">
        <Checkbox />
      </Form.Item>
    </>
  );
};

export default AddMemberComponent;
